import { IItemCategory } from "src/domain/entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id?: string
}

export async function itemCategoryListApi(
	payload: RequestDataShape,
	token?: null | string,
) {
	const endpoint = "/item/category/list/v1"
	const requester = new ApiRequester<RequestDataShape, IItemCategory[]>(endpoint)
	return await requester.sendRequest(payload, token)
}
